import { fetchUserContext } from '@/api/user-context';
import { useAuthStore } from '@/stores/auth.store';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { useQuery } from '@tanstack/react-query';

export function useUserContext() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const setUserContext = useRestaurantStore((s) => s.setUserContext);

  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      const ctx = await fetchUserContext();
      setUserContext(ctx);
      return ctx;
    },
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 10,
  });
}
